module.exports = __webpack_public_path__ + "static/media/hero_building_rendering.deefaf52.png";